import footfallEventTypes from 'src/constants/footfallEventTypes';
import config from 'config/config';
import axios from 'axios';
import { getCookieValue } from 'src/utils/cookie';
import { isUserBot } from 'src/utils/seo';
const isServer = typeof window === 'undefined';

let session = null; // this is a hack for now until footfall calls can be made without session params

const dashed = (str) => {
  return str.trim().replace(/([a-z\d])([A-Z]+)/g, '$1-$2').replace(/[-\s]+/g, '-').toLowerCase();
};

const footfallPendingEvents = [];

const checkSessionAndSendFootfall = () => {
  const pendingEventsLength = footfallPendingEvents.length;
  if (!!session) {
    for (let i = 0; i < pendingEventsLength; i++){
      const sendingEvent = footfallPendingEvents.shift();
      sendFootfallTracking(sendingEvent, session);
    }
  } else if (pendingEventsLength === 1) {
    axios.get(`${config.API_PATH}session/info`).then(response => {
      const sessionId = response.data.meta.session;
      session = sessionId;
      checkSessionAndSendFootfall();
    });
  }
};

// [CHAOS-131]
const getOriginalReferrer = function() {
  if (document.referrer.indexOf('healthunlocked.com') !== -1) {
    const huReferrer = getCookieValue('huReferrer');
    if (huReferrer || huReferrer === '') {
      return huReferrer;
    }
  }
  return document.referrer;
};

const sendFootfallTracking = (data, session) => {
  const sessionData = session.split(':');
  const formattedData = Object.assign(
    {
      'device-id': sessionData[0],
      'membership-id': sessionData[1],
      'fe-type': 'solaris',
    },
    ...Object.keys(data)
      .map(key => ({ [dashed(key)]: data[key] })),
  );
  axios.post('/footfall', JSON.stringify(formattedData), {
    headers: {
      'Accept': 'application/json',
    },
  });
};

const getTrackLocation = () => {
  return (location.pathname + location.hash + location.search).replace('#', '');
};

export const trackPage = () => {
  if (!isServer && config.environment !== 'development' && _gaq) {
    var trackLocation = getTrackLocation();
    _gaq.push(['_trackPageview', trackLocation]);
  }
  trackFootfallEvent(footfallEventTypes.VIEWED_PAGE);
};

export const trackPageNew = () => {
  if (!isServer && config.environment !== 'development') {
    ga('send', 'pageview', location.pathname);
  }
};

export const trackPageForPartner = (currentGroup) => {
  if (!isServer && config.environment !== 'development') {
    var trackLocation = getTrackLocation();

    if (!currentGroup || !currentGroup.gaTrackingCode) return;
    const trackerName = `communityTracker_${currentGroup.communityId}`;
    ga('create', {
      trackingId: currentGroup.gaTrackingCode,
      cookieDomain: 'none',
      name: trackerName,
    });
    ga(`${trackerName}.send`, 'pageview', trackLocation);
  }
};

export const trackEventForPartner = (currentGroup, category, action, label, value) => {
  if (isServer
      || config.environment === 'development'
      || !category || !action || !currentGroup || !currentGroup.gaTrackingCode) {
    return;
  }
  const trackerName = `communityTracker_${currentGroup.communityId}`;
  ga('create', {
    trackingId: currentGroup.gaTrackingCode,
    cookieDomain: 'none',
    name: trackerName,
  });
  ga(`${trackerName}.send`, 'event', category, action, label, value);
};

export const trackEvent = (category, action, label = undefined, value = undefined) => {
  if (!isServer && config.environment !== 'development' && _gaq) {
    var args = [category, action, label, value].filter(item => item);
    _gaq.push(['_trackEvent'].concat(args));
  }
};

export const trackEventWithFields = (category, action, label = undefined, value = undefined, fields = {}) => {
  if (!isServer && config.environment !== 'development' && _gaq) {
    _gaq.push(['_trackEvent', category, action, label, value, fields]);
  }
};

export const trackFootfallEvent = (eventType, trackData = {}) => {
  if (isServer || isUserBot) {
    return;
  }
  const data = {
    eventType,
    source: getSource(),
    'url': window.location.pathname + window.location.search,
    referrer: getOriginalReferrer(),
    ...trackData,
  };
  if(!!session) {
    sendFootfallTracking(data, session);
  } else {
    footfallPendingEvents.push(data);
    checkSessionAndSendFootfall();
  }
};

  // we delay the navigation to make sure the tracking event is sent before redirecting to BG
export const trackFootfallEventWithHrefDelay = (href, eventType, trackData = {}) => {
  trackFootfallEvent(eventType, trackData);
  setTimeout(() => {
    window.location.href = href;
  }, 300);
};

export const setUserType = (currentUser) => {
  const userType = !currentUser ? 'Visitor' : 'Member';
  if (window._gaq) {
    window._gaq.push(['_setCustomVar', 2, 'User Type', userType, 2]);
    window._gaq.push(['_setCustomVar', 4, 'User Type', userType, 3]);
  }
  if (window.ga) {
    window.ga('set', 'dimension1', 'solaris');
    window.ga('set', 'dimension2', userType);
  }
};

export const clearTrackingSession = () => {
  session = null;
};

const getSource = () => {
  const branch = window.HU_TEST_BRANCH !== 'A' ? ` ${window.HU_TEST_BRANCH}` : '';
  return `Betelgeuse${branch}`;
};



// WEBPACK FOOTER //
// ./src/utils/analytics.js